module.exports = __webpack_public_path__ + "static/media/accuracy.e861cd63.png";